function bodyManagerFeaturesStep(data, unitMeasurement) {
  const featuresWithUnit = ['CFT100', 'CFT101'];
  const body = {};
  const features = [];
  const CFTKeys = Object.keys(data);
  // eslint-disable-next-line no-unused-expressions
  CFTKeys?.forEach(k => {
    const feature = {
      feature_id: k,
      value: data[k]
    };
    if (featuresWithUnit.includes(k)) {
      // le agrego el id de unidad de medida uso cualquiera por que a esta altura esta validado que sean iguales
      feature.value_unit = unitMeasurement.total;
    }
    return features?.push(feature);
  });
  body.features = features;
  return body;
}

export { bodyManagerFeaturesStep };
